import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import {
    LinearProgress,
    Typography
} from '@material-ui/core';

const propTypes = {
    progress: PropTypes.number.isRequired,
    remainingTime: PropTypes.number,
    status: PropTypes.string.isRequired
};

const defaultProps = {
    remainingTime: 0
};

const useStyles = makeStyles((theme) => styles(theme));

function Progress ({ status, progress, remainingTime }) {
    const classes = useStyles();

    function getRemainingTime (milliseconds) {
        return milliseconds < 60000
            ? `${Math.ceil(milliseconds / 1000).toLocaleString(undefined, { maximumFractionDigits: 0 })} seconds remaining`
            : `${Math.ceil(milliseconds / 60000).toLocaleString(undefined, { maximumFractionDigits: 0 })} minutes remaining`;
    }

    if (!['running', 'queued', 'ready', 'complete'].includes(status)) {
        return <></>
    }

    //  Special case when there is no area for the backend to use to determine progress or remaining time
    if (progress === -1) {
        return (
            <div className={classes.progress}>
                <div className={classes.flex}>
                    <Typography color="textPrimary" variant="body2">
                        Searching: This may take some time
                    </Typography>
                </div>
                <LinearProgress
                    classes={{
                        root: classes.progressRoot,
                        bar: classes.progressBar
                    }}
                />
            </div>
        );
    }

    // Improve timer so changes based on how big the value
    return (
        <div className={classes.progress}>
            <div className={classes.flex}>
                <Typography color="textPrimary" variant="body2">
                    { progress < 100 ? `Searching: ${progress.toLocaleString(undefined, { maximumFractionDigits: 0 })}% Completed` : '100% Complete' }
                </Typography>
                {
                    remainingTime > 0 &&
                        <Typography color="textPrimary" variant="body2">
                            { getRemainingTime(remainingTime) }
                        </Typography>
                }
            </div>
            <LinearProgress
                classes={{
                    root: classes.progressRoot,
                    bar: classes.progressBar
                }}
                variant="determinate"
                value={progress}
            />
        </div>
    );
}

const styles = theme => ({
    flex: {
        display: 'flex',
        alignItems: 'center',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    },
    progress: {
        backgroundColor: `${theme.palette.grey.variant5}1A`,
        padding: '10px',
        '&> *:not(:last-child)': {
            marginBottom: 5
        }
    },
    progressRoot: {
        backgroundColor: 'initial',
        border: `1px solid ${theme.palette.background.border}`,
        height: 10
    },
    progressBar: {
        backgroundColor: theme.palette.primary.light
    }
});

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;

export default Progress;